module.exports = __webpack_public_path__ + "static/media/S1N3-3.dbac8d36.svg";